import type { QuoteDocument } from 'paintscout'

interface ToggleFollowUp {
  quote: QuoteDocument
  key: string
  enabled?: boolean
  sendText?: boolean
}
/**
 * Toggles whether a follow up is enabled by key for the Quote
 */
export function toggleFollowUp({ quote, key, enabled, sendText }: ToggleFollowUp): QuoteDocument {
  const disabled = typeof enabled === 'undefined' ? !quote.followUps?.[key]?.disabled : !enabled

  return {
    ...quote,
    followUps: {
      ...(quote.followUps ?? {}),
      [key]: {
        ...(quote.followUps?.[key] ?? {}),
        disabled,
        sendText
      }
    }
  }
}
